import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterState } from '@ui/shared/domain-filter';
import { FilterOption, type FilterSingleValue } from '@ui/shared/util-filter';
import { InputTextModule } from 'primeng/inputtext';
import { debounceTime, map, Observable, Subject, takeUntil } from 'rxjs';
import { BaseFilterComponent } from '../base-filter/base-filter.component';

const typingGracePeriod = 500;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-text-filter',
    templateUrl: './text-filter.component.html',
    styleUrls: ['./text-filter.component.scss', '../filter-element/filter-element.component.scss'],
    imports: [
        CommonModule,
        FormsModule,
        InputTextModule,
    ],
})
export class TextFilterComponent extends BaseFilterComponent implements OnDestroy {
    @Input()
    public override placeholder = 'Suchbegriff eingeben';

    public readonly value$: Observable<FilterSingleValue>;

    private readonly _filterValues$ = new Subject<Array<FilterOption>>();
    private readonly _destroyed$ = new Subject<undefined>();

    constructor(
        _activeFilterService: FilterState,
    ) {
        super(_activeFilterService);

        this._filterValues$
            .pipe(
                takeUntil(this._destroyed$),
                debounceTime(typingGracePeriod),
            )
            .subscribe(filterValues => {
                this.onValueChange(filterValues);
            });

        this.value$ = this.values$
            .pipe(
                map(values => values[0]?.value ?? ''),
            );
    }

    public ngOnDestroy(): void {
        this._destroyed$.next(undefined);
        this._destroyed$.complete();
    }

    public onTextChange(newValue: string | null): void {
        const filterValues = newValue
            ? [{ value: newValue, label: newValue }]
            : [];

        this._filterValues$.next(filterValues);
    }
}
